/**
 * Returns the displayable due date with a flag indicating whether the
 * value was computed as the LME-60 fallback (issueDate + 60 days) rather
 * than supplied directly by the structured invoice (BT-9).
 *
 * Per CLAUDE.md feedback memory `feedback_due_date_fallback_lme60`:
 * when `dueDate` is null the FE may compute the fallback and surface it
 * with an "estimée" badge so the comptable knows it's not authoritative.
 */
export interface DueDateInfo {
  iso: string | null;
  isEstimated: boolean;
}

export function resolveDueDate(
  dueDate: string | null | undefined,
  invoiceDate: string | null | undefined,
): DueDateInfo {
  if (dueDate) return { iso: dueDate, isEstimated: false };
  if (!invoiceDate) return { iso: null, isEstimated: false };
  const d = new Date(invoiceDate);
  if (Number.isNaN(d.getTime())) return { iso: null, isEstimated: false };
  d.setDate(d.getDate() + 60);
  return { iso: d.toISOString().slice(0, 10), isEstimated: true };
}
